import { Component, OnInit } from '@angular/core';
import {Session, evaluatorRole, evaluatorRoleProgram} from "../../../../../services/session.service";
import {ApiCallService} from "../../../../../services/api-call.service";
import {ErrorMessageService} from "../../../../../services/error-message.service";
import {first} from "rxjs/operators";
import {BlockUIService} from "ng-block-ui";
import {Router} from "@angular/router";

@Component({
    selector: 'app-user-roles',
    templateUrl: './user-roles.component.html',
    styleUrls: ['./user-roles.component.scss'],
    standalone: false
})
export class UserRolesComponent implements OnInit {

  roles: evaluatorRole[];
  currentEvaluatorProgramRequestKey: string = "";
  userOrgName: string;
  userOrgLogo: string;

  constructor(private Session: Session,
              private blockUI: BlockUIService,
              private ApiCallService: ApiCallService,
              private errorMessage: ErrorMessageService,
              private route: Router
  ) { }

  ngOnInit() {
    this.roles = this.Session.getEvaluatorRoles();
    const org = this.Session.getUserOrganization();
    this.userOrgName = org.name;
    this.userOrgLogo = org.topNavigationLogo;
    this.currentEvaluatorProgramRequestKey = this.Session.isEvaluatorWorkingForOtherInstitution();
  }

  setCurrentEvaluator(program: evaluatorRoleProgram){
    const programRequestKey = program && program.requestKey ? program.requestKey : "";
    this.blockUI.start("account-menu-ui");
    this.ApiCallService.postJsonData("/aeAMSsetCurrentEvaluator/", {programRequestKey : programRequestKey}).subscribe((response) =>{
      if(response.success){
        this.Session.reload().pipe(first()).subscribe((session) =>{
          this.blockUI.stop("account-menu-ui");
          this.route.navigate(["/home"]);
        })
      }
      else{
        this.blockUI.stop("account-menu-ui");
        this.errorMessage.showErrorModal("There was an error with opening the program", response.dataError);
      }
    })
  }
}
